<template>
  <FreeModal :name="name" persistent>
    <div class="space-y-6 text-center">
      <div class="space-y-1">
        <h2 class="text-text-neutral-primary text-lg font-semibold">
          <slot name="title" />
        </h2>
        <p class="text-text-neutral-secondary text-sm font-medium">
          <slot name="description" />
        </p>
      </div>
      <FreeButton
        type="button"
        class="gray-button text-text-neutral-secondary w-full text-lg font-semibold"
        @click="emit('onProceed')"
      >
        <slot name="buttonText" />
      </FreeButton>
    </div>
  </FreeModal>
</template>

<script setup lang="ts">
  import { FreeModal, FreeButton } from '../../../shared/ui';

  defineProps<{ name: string }>();
  const emit = defineEmits<{ onProceed: [] }>();
</script>
